import React, { FunctionComponent } from "react";

import { FlexDirection, Layout } from "@multiweb/reactComponents";
import { NotificationGroupId } from "@multiweb/types/contracts";
import { MenuNavigationSectionType } from "../../navigation";
import { MenuPanelItem } from "../MenuPanelItem";

export type NotificationPanelComponentProps = {
    /** Identifikátory položek panelu menu reprezentujících notifikační skupiny */
    notificationGroupPanelItemIds: readonly NotificationGroupId[];
};

/** Komponenta pro zobrazení položek panelu menu reprezentujících notifikační skupiny */
export const NotificationPanelComponent: FunctionComponent<NotificationPanelComponentProps> = ({ notificationGroupPanelItemIds }) => (
    <Layout
        flexDirection={FlexDirection.column}
        qa="menu-notifications-list"
    >
        {notificationGroupPanelItemIds.map((id) => (
            <MenuPanelItem
                key={id}
                {...{ id }}
                section={MenuNavigationSectionType.notificationGroups}
            />
        ))}
    </Layout>
);
